import { CoachItem as CoachItemComponent } from './CoachItem.component';
import { connector } from './CoachItem.connector';

export const CoachItem = connector(CoachItemComponent);
